import { UserCircleDuotone } from "@bonusx-global/bx-icons";
import type { SxProps } from "@mui/material/styles";
import type { ComponentType } from "react";

const ICON_MARKER_PATTERN = /^icon\(([\w-]+)\)$/;

const SURVEY_ICONS: Record<string, ComponentType<{ sx?: SxProps }>> = {
  "user-circle": UserCircleDuotone,
};

export function resolveSurveyIcon(value: string, sx?: SxProps): JSX.Element | null {
  const markerMatch = ICON_MARKER_PATTERN.exec(value.toLowerCase().trim());
  if (!markerMatch) {
    return null;
  }

  const IconComponent = SURVEY_ICONS[markerMatch[1]];
  if (!IconComponent) {
    return null;
  }

  return <IconComponent sx={sx} />;
}
